import { render, staticRenderFns } from "./CustomerComplete2.vue?vue&type=template&id=0b853bd8&"
import script from "./CustomerComplete2.vue?vue&type=script&lang=js&"
export * from "./CustomerComplete2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports